import { UserRole } from '@shared/modules/auth/classes/UserRole';

export type CandidateRequiredRoles = UserRole[] | null;

const candidateCommonRequiredRoles: Record<string, CandidateRequiredRoles> = {
  firstName: [UserRole.Candidate, UserRole.UserContact, UserRole.PhoneContact],
  lastName: [UserRole.Candidate, UserRole.UserContact, UserRole.PhoneContact],
  email: [UserRole.Candidate],
  needSendTermsNotification: [UserRole.Candidate],
  explorerUserId: [UserRole.UserContact, UserRole.PhoneContact],
  exploredDate: [UserRole.UserContact, UserRole.PhoneContact],
  phone: [UserRole.PhoneContact, UserRole.Candidate],
  preferredLanguageId: [UserRole.PhoneContact, UserRole.Candidate],
  newsletter: [UserRole.PhoneContact, UserRole.Candidate],
  cityId: [UserRole.PhoneContact, UserRole.Candidate],
  contactType: [UserRole.UserContact, UserRole.PhoneContact],
  source: [UserRole.Candidate, UserRole.UserContact, UserRole.PhoneContact],
};

export const candidateRequiredRolesLaborHireAts: Record<string, CandidateRequiredRoles> = {
  ...candidateCommonRequiredRoles,
};

export const candidateRequiredRolesStudentAts: Record<string, CandidateRequiredRoles> = {
  ...candidateCommonRequiredRoles,
  birthDate: [UserRole.Candidate, UserRole.PhoneContact],
  parentFirstName: [UserRole.Candidate, UserRole.PhoneContact],
  parentLastName: [UserRole.Candidate, UserRole.PhoneContact],
  parentEmail: [UserRole.Candidate, UserRole.PhoneContact],
};
